import * as React from "react";

const SvgRefluxT = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="349"
    height="104"
    fill="none"
    viewBox="0 0 349 104"
    {...props}
  >
    <path
     fill={rackColor}
      d="M5.097 0H105l-5.097 23H0zM94.69 81H265l-8.689 23H86zM249.097 0H349l-5.097 23H244z"
    ></path>
     <path
      d="M5.097 0H105l-5.097 23H0zM94.69 81H265l-8.689 23H86zM249.097 0H349l-5.097 23H244z"
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
  </svg>
);

export default SvgRefluxT;
